import {
  getReq,
  // postReq,
  // deleteSendReq,
  // putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  feeNameSearchInfo: {
    feeName: '',
    projId: '',
    compId: '',
    status: ''
  },
  feeNameListObject: {
    feeNameList: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  },
  feeNameInfo: {
    projId: '',
    feeId: '',
    feeName: '',
    feeDesc: '',
    parentFeeId: '',
    compId: '',
    orgFeeId: '',
    level: 0,
    seq: 0,
    status: '',
    indEndNode: '',
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0)
    // ,
    //
    // extCompName: ''
  },
  feeNameDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  // async insertFeeName({
  //   dispatch,
  //   commit,
  //   state
  // }, {projId, compId, parentFeeId}) {
  //   // debugger
  //   const insertObj = await postReq(END_POINTS.INSERT_RSP_FEE_NAME, {
  //     data: {
  //       // feeId: state.feeNameInfo.feeId,
  //       feeName: state.feeNameInfo.feeName,
  //       // feeDesc: state.feeNameInfo.feeDesc,
  //       // orgFeeId: state.feeNameInfo.orgFeeId,
  //       // level: state.feeNameInfo.level,
  //       // seq: state.feeNameInfo.seq,
  //       status: state.feeNameInfo.status,
  //       // indEndNode: state.feeNameInfo.indEndNode,
  //       //
  //       parentFeeId: parentFeeId,
  //       projId: projId,
  //       compId: compId
  //     },
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   return insertObj
  // },
  // async updateFeeName({
  //   dispatch,
  //   commit,
  //   state
  // }, {feeId, projId, compId, parentFeeId}) {
  //   let feeNameInfo = {
  //     // feeId: state.feeNameInfo.feeId,
  //     feeName: state.feeNameInfo.feeName,
  //     // feeDesc: state.feeNameInfo.feeDesc,
  //     // orgFeeId: state.feeNameInfo.orgFeeId,
  //     // level: state.feeNameInfo.level,
  //     // seq: state.feeNameInfo.seq,
  //     status: state.feeNameInfo.status,
  //     // indEndNode: state.feeNameInfo.indEndNode,
  //     //
  //     parentFeeId: parentFeeId,
  //     feeId: feeId,
  //     projId: projId,
  //     compId: compId
  //   }
  //   const updateObject = await putReq(END_POINTS.UPDATE_RSP_FEE_NAME, {
  //     data: feeNameInfo,
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   return updateObject
  // },
  // async removeFeeName({
  //   commit,
  //   state
  // }, {feeId, projId, compId}) {
  //   const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_FEE_NAME + `?feeId=${feeId}&projId=${projId}&compId=${compId}`, {
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   return deleteObject
  // },
  // async findFeeName({
  //   commit
  // }, {feeId, projId, compId}) {
  //   const responseData = await getReq(END_POINTS.FIND_RSP_FEE_NAME + `?feeId=${feeId}&projId=${projId}&compId=${compId}`, {
  //     headerMap: await getCPHeaderMap(compId, projId)
  //   })
  //   if (responseData.success) {
  //     commit('updateFeeNameInfo', responseData.data)
  //   } else {
  //     commit('updateFeeNameInfo', {})
  //   }
  // },
  // async findFeeNameCondition({
  //   commit,
  //   state,
  //   rootState
  // }, { currentPage, pageSize }) {
  //   let stateCurrentPage = currentPage
  //   if (pageSize) {
  //     state.feeNameListObject.pageSize = pageSize
  //     stateCurrentPage = 1
  //   }
  //   const feeNameListObject = await postReq(END_POINTS.FIND_RSP_FEE_NAME_CONDITION, {
  //     data: {
  //       currentPage: stateCurrentPage,
  //       orderBy: '',
  //       pageSize: state.feeNameListObject.pageSize,
  //       queryVO: {
  //         feeName: state.feeNameSearchInfo.feeName,
  //         projId: state.feeNameSearchInfo.projId,
  //         compId: state.feeNameSearchInfo.compId,
  //         status: state.feeNameSearchInfo.status
  //       },
  //       refreshTotalRecord: true
  //     },
  //     headerMap: await getCPHeaderMap(state.feeNameSearchInfo.compId, state.feeNameSearchInfo.projId)
  //   })
  //   commit('updateFeeNameListObject', feeNameListObject)
  // },
  async findRspFeeNameDDList({
    commit,
    state
  }, { projId, compId, codeParam }) {
    // debugger
    const responseData = await getReq(END_POINTS.FIND_RSP_FEE_NAME_DD_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateFeeNameDDList', responseData.data)
    } else {
      commit('updateFeeNameDDList', [])
    }
  },
  END_ACTIONS() {}
}

const mutations = {
  updateSearchFeeName(state, value) {
    state.feeNameSearchInfo.feeName = value
  },
  updateSearchProjId(state, value) {
    state.feeNameSearchInfo.projId = value
  },
  updateSearchCompId(state, value) {
    state.feeNameSearchInfo.compId = value
  },
  updateSearchStatus(state, value) {
    state.feeNameSearchInfo.status = value
  },
  //
  // updateProjId(state, value) {
  //   state.feeNameInfo.projId = value
  // },
  // updateFeeId(state, value) {
  //   state.feeNameInfo.feeId = value
  // },
  updateFeeName(state, value) {
    state.feeNameInfo.feeName = value
  },
  updateFeeDesc(state, value) {
    state.feeNameInfo.feeDesc = value
  },
  // updateParentFeeId(state, value) {
  //   state.feeNameInfo.parentFeeId = value
  // },
  // updateCompId(state, value) {
  //   state.feeNameInfo.compId = value
  // },
  // updateOrgFeeId(state, value) {
  //   state.feeNameInfo.orgFeeId = value
  // },
  // updateLevel(state, value) {
  //   state.feeNameInfo.level = value
  // },
  // updateSeq(state, value) {
  //   state.feeNameInfo.seq = value
  // },
  updateStatus(state, value) {
    state.feeNameInfo.status = value
  },
  // updateIndEndNode(state, value) {
  //   state.feeNameInfo.indEndNode = value
  // },
  // updateCrtBy(state, value) {
  //   state.feeNameInfo.crtBy = value
  // },
  // updateCrtOn(state, value) {
  //   state.feeNameInfo.crtOn = value
  // },
  // updateUpdBy(state, value) {
  //   state.feeNameInfo.updBy = value
  // },
  // updateUpdOn(state, value) {
  //   state.feeNameInfo.updOn = value
  // },
  //
  updateFeeNameListObject(state, feeNameListObject) {
    if (feeNameListObject.code === 2001) {
      state.feeNameListObject.feeNameList = feeNameListObject.data.map(value => {
        return {
          projId: value.projId,
          feeId: value.feeId,
          feeName: value.feeName,
          feeDesc: value.feeDesc,
          parentFeeId: value.parentFeeId,
          compId: value.compId,
          orgFeeId: value.orgFeeId,
          level: value.level,
          seq: value.seq,
          status: value.status,
          indEndNode: value.indEndNode,
          crtBy: value.crtBy,
          crtOn: value.crtOn,
          updBy: value.updBy,
          updOn: value.updOn
        }
      })
      state.feeNameListObject.currentPage = feeNameListObject.currentPage
      state.feeNameListObject.pageSize = feeNameListObject.pageSize
      state.feeNameListObject.total = feeNameListObject.total
      state.feeNameListObject.totalPage = feeNameListObject.totalPage
    } else {
      state.feeNameListObject.feeNameList = []
      state.feeNameListObject.total = 0
    }
  },
  updateFeeNameEmpty(state) {
    state.feeNameInfo.projId = ''
    state.feeNameInfo.feeId = ''
    state.feeNameInfo.feeName = ''
    state.feeNameInfo.feeDesc = ''
    state.feeNameInfo.parentFeeId = ''
    state.feeNameInfo.compId = ''
    state.feeNameInfo.orgFeeId = ''
    state.feeNameInfo.level = 0
    state.feeNameInfo.seq = 0
    state.feeNameInfo.status = ''
    state.feeNameInfo.indEndNode = ''
    state.feeNameInfo.crtBy = ''
    state.feeNameInfo.crtOn = new Date(0)
    state.feeNameInfo.updBy = ''
    state.feeNameInfo.updOn = new Date(0)
  },
  updateFeeNameInfo(state, feeNameInfo) {
    state.feeNameInfo.projId = feeNameInfo.projId
    state.feeNameInfo.feeId = feeNameInfo.feeId
    state.feeNameInfo.feeName = feeNameInfo.feeName
    state.feeNameInfo.feeDesc = feeNameInfo.feeDesc
    state.feeNameInfo.parentFeeId = feeNameInfo.parentFeeId
    state.feeNameInfo.compId = feeNameInfo.compId
    state.feeNameInfo.orgFeeId = feeNameInfo.orgFeeId
    state.feeNameInfo.level = feeNameInfo.level
    state.feeNameInfo.seq = feeNameInfo.seq
    state.feeNameInfo.status = feeNameInfo.status
    state.feeNameInfo.indEndNode = feeNameInfo.indEndNode
  },
  updateFeeNameDDList(state, list) {
    // state.feeNameDDList = value
    let feeNameDDList = Utils.toListWapper(list, {valueField: 'feeId', descrField: 'feeName'})
    let feeNameDDMap = {}
    let newList = []
    let resultList = []
    feeNameDDList.forEach(item => {
      item.children = []
      feeNameDDMap[item.value] = item
      if (item.level === 1) {
        item.number = item.seq + ''
        // feeNameDDMap[item.value] = item
        newList.push(item)
      } else {
        let index = 1
        let parentItem = feeNameDDMap[item.parentFeeId]
        feeNameDDMap[item.parentFeeId].children.push(item)
        item.number = item.seq
        while (index++ < item.level) {
          item.number = parentItem.seq + '.' + item.number
          parentItem = feeNameDDMap[parentItem.parentFeeId]
        }
      }
    })

    newList.forEach(item => {
      resultList.push(item)
      item.children.forEach(item => {
        resultList.push(item)
        item.children.forEach(item => {
          resultList.push(item)
        })
      })
    })
    state.feeNameDDList = resultList
    // debugger
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/conf/rspFeeNameManage.js